/**
 * Service Details section for PM Inspection Process.
 * Actual UM at Time of Service is entered in the service bar.
 * Fields here: Service Date and Technician.
 *
 * Validates: Requirements 9.4
 */

import { DateField, Select } from '../ui';

export interface ServiceDetailsData {
    actualUM: string;
    serviceDate: string;
    technicianId: string;
    technicianName: string;
}

interface ServiceDetailsSectionProps {
    data: ServiceDetailsData;
    onChange: (data: ServiceDetailsData) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    users: any[];
}

export const ServiceDetailsSection = ({
    data,
    onChange,
    users,
}: ServiceDetailsSectionProps) => {
    return (
        <div className="pm-inspection-section">
            <h3 className="pm-inspection-section-title">Service Details</h3>
            <div className="pm-inspection-form-grid">
                <div className="pm-inspection-field">
                    <label className="pm-inspection-label" htmlFor="pm-service-date">
                        Service Date
                    </label>
                    <DateField
                        inputId="pm-service-date"
                        ariaLabel="Service Date"
                        value={data.serviceDate}
                        onChange={(serviceDate) => onChange({ ...data, serviceDate })}
                    />
                </div>

                <div className="pm-inspection-field">
                    <label className="pm-inspection-label" htmlFor="pm-technician">
                        Technician
                    </label>
                    <Select
                        inputId="pm-technician"
                        ariaLabel="Technician"
                        placeholder="Select technician"
                        options={users.map((user) => ({
                            value: user.id,
                            label: user.name || user.email || user.id,
                        }))}
                        value={data.technicianId}
                        onChange={(technicianId) => {
                            const selected = users.find((user) => user.id === technicianId);
                            onChange({
                                ...data,
                                technicianId,
                                technicianName: selected?.name ?? '',
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
